module.exports = __webpack_public_path__ + "src/assets/img/share/level2/919ae447e950ce589324ac079c33ca15.png";